var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('navbar',{attrs:{"isHiddenlogin":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }